<template>
    <section class="module-realtime-section">
        <div id="left-panel">
            <UsersTable :socketClient="socketClient" :reconnection="reconnection" :enabledListeners="enabledListeners"
                :usersList="usersList" :queueList="queueList" :currentCalls="currentCalls" :peersStatus="peersStatus"
                :queueMembers="queueMembers" :view="view" @emitIntermediate="emitter"
                @open-details-modal="openDetailsModal" />
        </div>
        <div id="right-panel">
            <div class="queue-table-title">
                <span>{{
                    dynamicTable.queue.display === 1 ? 'Ligações em fila'
                        : dynamicTable.queue.display === 2 ? 'Operadores em pausa'
                    : 'Avisos Ativos na URA'
                    }}</span>
                <div class="toggle-chart-buttons">
                    <div class="badge mode-icon"
                        :title="dynamicTable.queue.mode === 'fixed' ? 'Modo Fixo' : 'Modo Automático'"
                        @click="changeTableMode('queue')">
                        <i class="fas"
                            :class="{ 'fa-bar-chart': dynamicTable.queue.mode === 'fixed', 'fa-random': dynamicTable.queue.mode === 'auto' }"></i>
                        {{ dynamicTable.queue.mode === 'fixed' ? 'Fixo' : 'Auto' }}
                    </div>
                    <div class="badge change-icon" @click="changeTableDisplay('queue')">
                        <i class="fas fa-refresh"></i>Alternar
                    </div>
                </div>
            </div>
            <div id="queue-table-component">
                <QueueTable v-show="dynamicTable.queue.display === 1" :socketClient="socketClient"
                    :reconnection="reconnection" :enabledListeners="enabledListeners" :queueList="queueList"
                    :queueCalls="queueCalls" :view="view" />
                <PausesTable v-show="dynamicTable.queue.display === 2" :socketClient="socketClient"
                    :reconnection="reconnection" :enabledListeners="enabledListeners" :usersList="usersList"
                    :queueList="queueList" :queueMembers="queueMembers" :view="view"
                    @open-details-modal="openDetailsModal" />
            </div>

            <AvisosAtivos v-show="dynamicTable.queue.display === 3" :key="avisosKey" />
        </div>
        <PauseDetails v-if="showPauseDetails" :user="userInfo" :mode="detailsMode" @close-modal="closeDetailsModal"
            @emitIntermediate="emitter" :pausesList="pausesList" />
    </section>
</template>

<script>
import UsersTable from '../components/tables/UsersTable'
import QueueTable from '../components/tables/QueueTable'
import PausesTable from '../components/tables/PausesTable'
import AvisosAtivos from '../components/tables/AvisosAtivos'
import PauseDetails from '../components/modals/PauseDetails.vue'
export default {
    props: {
        socketClient: { type: Object || null, default: null },
        reconnection: { type: Boolean, default: false },
        enabledListeners: {
            type: Object,
            default: {
                queueCalls: false,
                currentCalls: false,
                queueMembers: false,
                peerStatus: false
            }
        },
        queueList: { type: Array, default: [] },
        usersList: { type: Array, default: [] },
        currentCalls: { type: Array, default: [] },
        queueMembers: { type: Array, default: [] },
        peersStatus: { type: Array, default: [] },
        queueCalls: { type: Array, default: [] },
        view: { type: String }
    },
    components: {
        UsersTable,
        QueueTable,
        PausesTable,
        PauseDetails,
        AvisosAtivos
    },
    data() {
        return {
            dynamicTable: {
                queue: {
                    length: 3,
                    display: 1,
                    mode: 'auto',
                    autoIntervalId: null,
                    autoInterval: 13033
                }
            },
            showPauseDetails: false,
            userInfo: {},
            detailsMode: 'view',
            pausesList: [],
            avisosKey: 0,
        }
    },
    async mounted() {
        const tables = Object.entries(this.dynamicTable)
        if (tables.length) {
            tables.map(el => {
                if (el[1].mode === 'auto') this.startTableAutoMode(el[0])
            })
        }
        this.getPausesList()
    },
    beforeDestroy() {
        this.stopTableAutoMode('queue')
    },
    methods: {
        emitter(data) {
            this.$emit('emitEvent', data)
        },
        changeTableMode(type) {
            if (this.dynamicTable[type].mode === 'fixed') {
                this.dynamicTable[type].mode = 'auto';
                this.startTableAutoMode(type);
            } else if (this.dynamicTable[type].mode === 'auto') {
                this.dynamicTable[type].mode = 'fixed';
                this.stopTableAutoMode(type);
            }
        },

        changeTableDisplay(type) {
            const length = this.dynamicTable[type].length;
            if (this.dynamicTable[type].display < length) {
                this.dynamicTable[type].display++;
            } else {
                this.dynamicTable[type].display = 1;
            }
            if (type === 'queue' && this.dynamicTable[type].display === 3) {
                this.avisosKey++;
            }
        },

        startTableAutoMode(type) {
            this.stopTableAutoMode(type);

            if (this.dynamicTable[type].mode === 'auto') {
                this.dynamicTable[type].autoIntervalId = setInterval(() => {
                    this.changeTableDisplay(type);
                }, this.dynamicTable[type].autoInterval);
            }
        },

        stopTableAutoMode(type) {
            if (this.dynamicTable[type].autoIntervalId) {
                clearInterval(this.dynamicTable[type].autoIntervalId);
                this.dynamicTable[type].autoIntervalId = null;
            }
        },
        openDetailsModal(data) {
            if (this.userInfo.id && this.userInfo.id !== data.user.id) {
                this.userInfo = data.user;
                return;
            } else {
                this.userInfo = data.user;
            }

            if (!this.showPauseDetails) this.showPauseDetails = true;
            this.detailsMode = data.mode
        },
        closeDetailsModal() {
            this.userInfo = {}

            this.showPauseDetails = false;
            this.detailsMode = 'view'
        },
        getPausesList() {
            axios.get('pauses-list').then(({ data }) => {
                if (data.length) {
                    this.pausesList = data
                }
            })
        }
    }
}

</script>

<style lang="scss" scoped>
.queue-table-title {
    text-align: center;
    font-size: medium;
    font-weight: bold;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
}

.module-realtime-section {
    display: flex;
    margin: 20px;
}

#left-panel {
    flex: 2;
}

#right-panel {
    display: flex;
    flex-direction: column;
    margin: 10px;
    flex: 1;
    border-radius: 20px;
    box-shadow: 1px 1px 3px 0px lightgray;
    background-color: #f9f4f4;
}

#queue-table-component {
    margin: 5px;
}

.toggle-chart-buttons {
    display: flex;
    gap: 3px;
    padding: 3px;

    div {
        opacity: 0.4;
        cursor: pointer;
        color: white;
        width: 70px;
        display: flex;
        gap: 3px;
        justify-content: center;
        transition: 0.4s ease-in-out;
    }

    .mode-icon {
        &:hover {
            opacity: 1;
        }

        background-color: #cf1111;
    }

    .change-icon {
        &:hover {
            opacity: 1;
        }

        background-color: #1c869a;
    }
}
</style>